export default {
  sentiment: 'Sentiment',
  medias: 'Media',
};
